type Translations = Record<string, Record<string, string>>;

const getLocale = () =>
  // Detect locale from html tag
  // If not specified use browser locale settings from navigator.language
  // If browser locale was not specified either, fall back to en-US
  document.querySelector('html').getAttribute('lang') ??
  // https://caniuse.com/?search=navigator - safe to suppress this eslint error
  // eslint-disable-next-line compat/compat
  navigator.language ??
  'en-US';

/**
 * Takes into account user specified locale override.
 * If none is specified, detects the locale from HTML tag -> browser navigator
 * and returns the translation in the detected locale.
 *
 * If no translation is found in any of the specified locales,
 * returns string in en-US as the last resort.
 *
 * If after all attempts en-US does not exist either, returns undefined
 */
export const katTranslator =
  <T extends Translations>(strings: T) =>
  (stringId: keyof T, options?: Record<string, string>, locale?: string) => {
    let translation = strings[stringId][locale ?? getLocale()];
    translation = translation ?? strings[stringId]['en-US'];

    if (options) {
      Object.keys(options).forEach(key => {
        const value = options[key];
        translation = translation?.replace(
          new RegExp('{' + key + '}', 'g'),
          value
        );
      });
    }

    return translation;
  };
